/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Peruuta',
    CLOSE: 'Sulje',
    CONFIRM: 'Vahvista',
    CONFIRM_AND_NEXT: 'Vahvista ja seuraava',
    CONFIRM_AND_SAVE: 'Vahvista ja tallenna',
    CREATE: 'Luo',
    DELETE: 'Poista',
    EDIT: 'Muokkaa',
    NEW_POST: 'Uusi julkaisu',
    OK: 'OK',
    REJECTED: 'Hylätyt',
    REPLY: 'Vastaa',
    SAVE: 'Tallenna',
    SEND: 'Lähetä',
    SKIP_CROP: 'Jätä leikkaus huomiotta',
    UPDATE: 'Päivitys',
    UPGRADE: 'Liittyä klubiin'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'kopiointi leikepöydälle epäonnistuu!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Postauksen jakamisessa Instagramissa tapahtui virhe.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Postauksen jakamisessa Instagramissa tapahtui virhe. Haluatko jatkaa julkaisua?',
    LINK_ALREADY_EXISTS: 'Linkki on jo olemassa',
    LINK_VALIDATION_FAILED: 'Linkkiä ei voitu vahvistaa',
    MANDATORY_FIELD: 'Pakollinen kenttä',
    MAXIMUM_CHARACTERS: 'Maksimimerkit saavutettu',
    MAXIMUM_FILE_SIZE: 'Suurin sallittu koko on 100MB!',
    MINIMUM_DIMENSIONS: 'Ladatun tiedoston vähimmäismitat ovat 480×960',
    PAGE_NOT_APPROVED:
      '❌ Valitettavasti sivuasi ei voitu hyväksyä tällä kertaa. Mutta älä huoli! ✨\n Voit muokata profiiliasi ja korjata ilmoitetut kentät lähettääksesi sen uudelleen hyväksyttäväksi.',
    REACTION_LIKE: 'On tapahtunut virhe, yritä myöhemmin uudelleen!',
    UNSUPPORTED_FORMAT: 'Formaattia ei tueta!',
    VIDEO_CROP: 'Videon leikkaus epäonnistui!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Hyväksyn ehdot',
    ADDITIONAL_INFORMATION: 'Additional information',
    ADDRESS: 'Address',
    APPROVED: 'julkaistu',
    ASSETS: 'Kuvat tai videot (enimmäiskoko 100 Mt)',
    ASSOCIATE_PRODUCT: 'Associate prozis tuote',
    ASSOCIATED_PRODUCTS: 'Liittyvät prozis-tuotteet',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Kuvateksti',
    CHART_BY: 'Graafinen kuvaaja',
    COMMENTS: 'Kommentit',
    COMMISSION: 'komissio',
    COMMISSIONS: 'palkkiot',
    COMMISSIONS_LAST_30_DAYS: 'viimeiset 30 päivää',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Full address without house number',
    CONTINUE_WITH_INSTAGRAM: 'Jatka Instagramissa',
    COUNTRY: 'Address with country only',
    CREATE_PROFILE: 'Luo profiili',
    CROPPING_ASSET: 'Leikkaus {asset} {ratio}',
    DELETE_POST: 'Poista viesti?',
    DELETE_POST_ARE_YOU_SURE: 'Oletko varma, että haluat poistaa viestin?',
    DESCRIPTION: 'Elämäkerta',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Lataa',
    DRAFT_PROFILE: 'Luonnos',
    EDIT_PROFILE: 'Muokkaa profiilia',
    ENGAGEMENT: 'Vuorovaikutus',
    ERROR: 'Virhe',
    FEED: 'syöttö',
    FOLLOWERS: 'Seuraajat',
    FRIDAY: 'Friday',
    GALLERY: 'Galleria',
    HIDDEN: 'Does not show address',
    IMAGE: 'kuva',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Instagram-tili',
    LATEST_FIRST: 'Viimeisin ensimmäinen',
    LEAST_PROFITABLE: 'Vähemmän tuottoisat ensin',
    LIKES: 'Kuten',
    LIKES_DELETED: 'Tykkää poistaa',
    LINK: 'Linkki ',
    LIVE: 'Suora',
    LIVES: 'Suora',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Osoite vain kaupungilla ja maalla',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Täydellinen osoite',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Täydellinen osoite ilman ovikertaa',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Osoite vain maalla',
    MONDAY: 'Monday',
    MORE: '... Katso lisää',
    MOST_PROFITABLE: 'Tuottoisimmat ensin',
    NAME: 'Nimi',
    NEW_FOLLOWERS: 'Uusia seuraajia',
    NEW_POST: 'Uusi julkaisu',
    NO_PRODUCTS_FOUND: 'Tuotetta ei löytynyt.',
    NUMBER_OF_FILES: '{file} of {files}',
    OLDEST_FIRST: 'Vanhin ensin',
    ORIGINAL: 'Alkuperäinen',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Sivun kuvat',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'vireillä',
    POST: 'Julkaisu',
    POST_COMMENTS: 'Julkaisua koskevat huomautukset',
    POST_PRODUCTS: 'Julkaisutuotteet',
    POST_VIEWS: 'Julkaisunäkymät',
    POSTING_ON_INSTAGRAM: 'Postaus Instagramissa',
    POSTS: 'Julkaisut',
    PRODUCTS_HASHTAGS: 'Tuoteselosteet',
    PRODUCTS_LINKS: 'Tuotelinkit',
    PROFESSIONAL_PAGE: 'Professional Page',
    PROFILE: 'Profiili',
    PROFILE_PHOTO: 'Profiilikuva',
    PROFILE_STATUS: 'Profiilin tila',
    PROFILE_VIEWS: 'Profiilinäkymät',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Prozis-yhteisö',
    QUESTION: 'Kysymys',
    QUESTION_REPLY: 'Vastaa kysymykseen',
    QUESTIONS: 'Kysymykset',
    REELS: 'kiekot',
    REJECTED: 'julkaisematon',
    REJECTED_PROFILE: 'Hylätyt',
    REJECTION_REASON: 'Hylkäämisen syy',
    REPLY: 'Vastaa',
    REQUIRED_FIELDS: 'Pakolliset kentät',
    RESET: 'Kirkas',
    SATURDAY: 'Saturday',
    SEARCH: 'Etsi',
    SEARCH_AT_LEAST: 'Etsittävän sanan on oltava vähintään 3 merkkiä pitkä!',
    SEE_LESS: 'Hide',
    SEE_MORE: 'Katso lisää',
    SEE_ORIGINAL: 'Katso alkuperäinen',
    SEE_TRANSLATION: 'Katso käännös',
    SHARE_ON_INSTAGRAM: 'Jaa Instagramissa',
    SHARE_PROFILE: 'Jaa profiili',
    SOCIAL_NETWORK: 'Sosiaalinen verkostoituminen',
    SOCIAL_NETWORK_COMMISSIONS: 'Sosiaalisen verkoston komiteat',
    SOCIAL_NETWORK_PAGE: 'Sosiaalinen sivu',
    SOUND: 'Ääni',
    SPECIALTIES: 'Erikoisuudet',
    STATISTICS_POST: 'Julkaisutilastot',
    STATISTICS_PROFILE: 'Profiilin tilastot',
    STATS_POST_TOTAL: 'Julkaisupalkkiot yhteensä',
    STATS_POST_TOTAL_COMMENTS: 'Julkaisua koskevat kommentit/kysymykset',
    STATS_POST_TOTAL_LIKES: 'Julkaisusta saadut tykkäykset',
    STATS_POST_TOTAL_PRODUCTS: 'Julkaisuun liittyvät tuotteet',
    STATS_POST_TOTAL_QUESTIONS: 'Julkaisussa vastatut kysymykset',
    STATS_POST_TOTAL_VALUE: 'Julkaisun arvo',
    STATS_PROFILE_TOTAL: 'Julkaisupalkkiot yhteensä',
    STATS_PROFILE_TOTAL_COMMENTS: 'Julkaisuja koskevat kommentit/kysymykset',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Uusia seuraajia saatu',
    STATS_PROFILE_TOTAL_LIKES: 'Julkaisuista saadut tykkäykset',
    STATS_PROFILE_TOTAL_POSTS: 'Julkaisuista saatu arvo',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Julkaisuihin liittyvät tuotteet',
    STATS_PROFILE_TOTAL_QUESTIONS:
      'Julkaisuja koskeviin kysymyksiin vastatut kysymykset',
    STORY: 'tarina',
    SUCCESS: 'Menestys',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Ehdot ja edellytykset',
    THURSDAY: 'Thursday',
    TITLE: 'Otsikko',
    TOTAL_VIEWS: 'Yhteensä katselukertoja',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Ei-seuraajat',
    UNREAD: 'Lukeminen',
    UPDATE_POST: 'Päivitysjulkaisu',
    UPDATED: 'Päivitetty {date}',
    UPLOAD: 'Tiedoston lataaminen',
    UPLOADING_FILES: 'Tiedoston (tiedostojen) lähettäminen',
    USER_NAME: 'Käyttäjän nimi',
    VIDEO: 'video',
    VIEW_ALL_COMMENTS: 'Katso {total} kommentit',
    VIEW_MORE: 'Katso lisää',
    VIEWS: 'Visualisoinnit',
    VISIBILITY_LEVEL: 'Visibility level',
    WAITING_APPROVAL: 'Odottaa hyväksyntää',
    WARNING: 'Varoitus',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Profiilisi'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Kysymyksiä ei ole vielä esitetty.',
    TERMS_AND_CONDITIONS:
      'Vuorovaikutuksessa Prozisin "sosiaalisen verkoston" kanssa (esimerkiksi kommentoimalla ja/tai jakamalla sisältöä ja reaktioita suoraan) käyttäjä vakuuttaa lukeneensa, ymmärtäneensä ja hyväksyneensä seuraavat käyttöehdot (T&amp;C).\n\nProzis pidättää oikeuden päivittää käyttöehtoja milloin tahansa ilman ennakkoilmoitusta. Prozisilla on oikeus käyttää kaikkia käytettävissään olevia oikeudellisia ja kohtuullisia oikeussuojakeinoja.\n\nKäyttäjä vakuuttaa "Sosiaaliseen verkostoon" liittymällä olevansa vähintään 18-vuotias ja ottaa kaiken vastuun itse "Sosiaaliseen verkostoon" ladatuista julkaisuista, kommenteista, kuvista ja videoista ("Sisältö").\n\nSisällön on kuuluttava Käyttäjälle, joka vakuuttaa olevansa kaiken immateriaalioikeuden tekijä ja omistaja. Sisältö ei saa edustaa mitään tiettyä tilannetta, rakennusta tai kohdetta ja/tai tekijänoikeudella, tavaramerkillä tai yleensä muiden yritysten tavaramerkillä ja logoilla suojattua sisältöä, ellei Käyttäjä ole saanut tarvittavaa suostumusta sen käyttöön.\n\nSisältö ei saa sisältää muita henkilöitä kuin Käyttäjä, ellei sama henkilö ole antanut kirjallista suostumusta, jonka hankkiminen on Käyttäjän vastuulla. Käyttäjän on korvattava Prozisin vahingot ja pidettävä Prozis vahingoittumattomana, jos tällaisten kuvien ja/tai videoiden käytöstä aiheutuu vahinkoa.\n\nKun sisältö on jaettu, se on Prozisin yksinomaista omaisuutta, ja Prozisilla on oikeus julkaista ja/tai levittää ja/tai käyttää ja/tai jäljentää ja/tai välittää ja/tai muuttaa edellä mainittua sisältöä millä tahansa teknisellä keinolla ja millä tahansa tavalla ilman rajoituksia, ilman aikarajoituksia ja ilman oikeutta korvauksiin ja/tai hyvityksiin asianosaisille ja/tai asianomaisille.\n\nMahdollisen sisällön lataamisen jälkeen Prozis pidättää oikeuden jättää näkyviin vain sellaista materiaalia, joka ei sen oman kiistattoman arvion mukaan ole vahingollista toisten imagolle eikä loukkaa nykyistä moraalia tai muutoin loukkaa toisten oikeuksia; puolueellinen, herjaava, säädytön, mauton, herjaava, rasistinen, tai joka on mainosmuoto jollekin kaupalliselle toiminnalle, joka ei kuulu ehdotettuun aiheeseen, tai joka tapauksessa, jonka tarkoituksena on mainostaa mitä tahansa tuotemerkkiä, tuotetta tai palvelua, joka ei ole "sosiaalisen verkoston" tuotemerkki, tuote tai palvelu, jonka sisältö ei ole alkuperäistä Käyttäjälle, eli joka on kopioitu toisista lähteistä, jonka sisältö on vastoin Portugalin oikeusjärjestelmää, joka on vastoin julkista säädyllisyyttä, yksityisyyden suojaa koskevia säännöksiä ja yleisesti ottaen voimassa olevaa lainsäädäntöä.\n\nProzis pidättää myös oikeuden poistaa ennen julkaisua tai sen jälkeen kaikki kommentit, jotka sen oman harkinnan mukaan voivat olla loukkaavia, sopimattomia ja/tai ristiriidassa "sosiaalisen verkoston" hengen kanssa.\n\nProzis pidättää myös oikeuden milloin tahansa poistaa sosiaalisessa verkostossaan julkaistuja kommentteja ja/tai sisältöä itsenäisesti tai kolmansien osapuolten pyynnöstä sekä oikeusviranomaisten pyynnöstä, jos kyseisen julkaisun tai kommentin laillisuudesta tai oikeutuksesta syntyy kiistaa. Sisältö jätetään näkyviin vain, jos "sosiaalisen verkoston" moderointi pitää sitä asianmukaisena.\n\nKun sisältö on ladattu "sosiaaliseen verkostoon", Prozis pidättää oikeuden ladata tai jakaa uudelleen käyttäjäsisältöä suoraan digitaalisilla alustoillaan brändinsä edistämiseksi.',
    WITHOUT_POSTS: 'Julkaisuja ei ole vielä julkaistu.',
    WITHOUT_POSTS_STATISTICS:
      'Valittujen päivämäärien välillä ei ole julkaisuja.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Linkki onnistuneesti kopioitu leikepöydälle!',
    CREATED_SUCCESSFULLY: 'Onnistuneesti luotu!',
    ERROR_PUBLISHING_INSAGRAM: 'Postaus julkaistiin Instagramissa.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'Postaus julkaistiin onnistuneesti Instagramissa.',
    POST_CREATED_SUCCESSFULLY: 'Onnistuneesti luotu!',
    POST_SAVED_SUCCESSFULLY: 'Onnistunut päivitys!',
    POST_SUCCESSFULLY_DELETED: 'Onnistuneesti eliminoitu.',
    SAVED_SUCCESSFULLY: 'Onnistunut päivitys!',
    SUCCESSFULLY_DELETED: 'Onnistuneesti poistettu.',
    SUCCESSFULLY_REPLIED: 'Onnistunut vastaus.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS: 'Hyväksy ehdot!',
    EMPTY_PROFILE_IMAGE: 'Sinun on ladattava profiilikuva!',
    INVALID_FORM: 'Virheellinen lomake!'
  }
};
